import React, { FunctionComponent } from 'react'

import { SpaceProps, WidthProps } from 'styled-system'

import { Input, Label, Slider, StyledSwitch } from './styled-switch'

interface Props {
  label: string
  checked: boolean
  onChange: () => void
  fieldProps: SpaceProps & WidthProps
}

const Switch: FunctionComponent<Props> = ({ label, checked, onChange, fieldProps }) => {
  const handleOnChange = (): void => onChange && onChange()

  return (
    <StyledSwitch {...fieldProps}>
      <Input id={label} type="checkbox" checked={checked} onChange={handleOnChange} />
      <Slider htmlFor={label} />
      <Label htmlFor={label}>{label}</Label>
    </StyledSwitch>
  )
}

export default Switch
